module.exports = __webpack_public_path__ + "static/media/collaborator_icon.2b3a1f62.png";